module.exports = __webpack_public_path__ + "static/media/P-4.05b6370d.png";